type FullscreenErrorProps = {
    message?: string;
    onRetry?: () => void;
};

export default function FullscreenError({
    message = "Произошла ошибка",
    onRetry,
}: FullscreenErrorProps) {
    return (
        <div className="fullscreen-loader error">
            <div className="loader-content">
                <div className="error-icon">!</div>
                <div className="loader-text">{message}</div>

                {onRetry && (
                    <button className="error-button" onClick={onRetry}>
                        Повторить
                    </button>
                )}
            </div>
        </div>
    );
}
